module.exports = __webpack_public_path__ + "static/media/search.26332736.svg";